'use client';

import { useMemo } from 'react';
import ConcernsCarouselClient from './ConcernsCarousel/ConcernsCarouselClient';
import { WhatIsYourConcern } from '@/types/components/whatIsYourConcern';

type Props = {
  data: WhatIsYourConcern;
  concernOverlayClassName?: string;
};

const ConcernAndTreatmentsSection = ({
  data,
  concernOverlayClassName,
}: Props) => {
  const concerns = useMemo(() => data?.cards || [], [data]);

  if (!concerns.length) return null;

  return (
    <section
      id="private-ultrasound-scans-concerns"
      data-testid="content-wrapper"
      className="content-wrapper laptop:mt-12 mt-8 overflow-x-hidden"
    >
      <ConcernsCarouselClient
        data={data}
        concerns={concerns}
        concernOverlayClassName={concernOverlayClassName}
      />
    </section>
  );
};

export default ConcernAndTreatmentsSection;
